import { ConfirmationDialogService } from "./../../../confirmation-dialog/service/confirmation-dialog.service";
import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FieldConfig } from "app/genericForm/field.interface";
import { ModalAbmComponent } from "../modal-abm/modal-abm.component";
import { OneToManyService } from "../service/one-to-many.service";
import { OperacionAbmEnum } from "app/enums/operacion-abm.enum";
import { SubmitService } from "../../submit/service/submit.service";
import { ProveedoresService } from "app/service/proveedores.service";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: "app-one-to-many",
  template: `
    <div class="row mb-2" *ngIf="!hidden()">
      <div class="col-6 text-left">
        <label>{{ field.label }}</label>
      </div>
      <div class="col-6 text-right">
        <button
          *ngIf="!noEsVer()"
          mat-raised-button
          color="secondary"
          type="button"
          class="mat-focus-indicator mat-raised-button mat-button-base mat-secondary"
          (click)="agregar()"
        >
          +
        </button>
      </div>
      <div class="col-12">
        <mat-card-content class="">
          <div class="table-generic">
            <div class="row py-2 mx-4 header-row">
              <div
                class="col header-cell text-info"
                *ngFor="let header of getHeadersOrder()"
              >
                {{ header.title }}
              </div>
              <div class="col header-cell"></div>
            </div>
            <div class="row py-2 mx-4" *ngIf="field.collections.length === 0">
              <div class="col-12 text-center px-0">
                <div class="alert alert-info" role="alert">
                  No hay elementos
                </div>
              </div>
            </div>
            <div
              class="row py-2 mx-4 table-row"
              *ngFor="let dataRow of field.collections"
            >
              <div
                class="col header-cell"
                *ngFor="let header of getHeadersOrder()"
              >
                {{ getValue(dataRow, header.objectKey) }}
              </div>
              <div class="col  header-cell">
                <button
                  type="button"
                  mat-raised-button
                  color="secondary"
                  *ngIf="field.buttonsRowConfig.viewActive"
                  (click)="downloadFile(dataRow)"
                  class="mx-1">
                    Descargar
                </button>
                <button
                  type="button"
                  mat-raised-button
                  color="secondary"
                  *ngIf="field.buttonsRowConfig.editActive"
                  (click)="editar(dataRow)"
                  class="mx-1"
                >
                  <i class="nb-edit icon-size"></i>
                </button>
                <button
                  type="button"
                  mat-raised-button
                  color="secondary"
                  *ngIf="field.buttonsRowConfig.deleteActive"
                  (click)="eliminar(dataRow)"
                >
                  <i class="nb-trash icon-size"></i>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </div>
    </div>
  `,
  styles: [],
})
export class OneToManyComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  modalAgregar: NgbModalRef;
  fieldsModal: FieldConfig[];
  @Input() valueChangeCallbackModal: (args: any) => void;
  @HostBinding("class") class = "";
  constructor(
    private modalService: NgbModal,
    private oneToManyService: OneToManyService,
    private confirmationDialogService: ConfirmationDialogService,
    private submitService: SubmitService,
    private sanitizer: DomSanitizer
  ) {}
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    if (!this.field.collections) {
      this.field.collections = [];
    }
  }

  getHeadersOrder() {
    return this.field.collectionsHeader
      ? this.field.collectionsHeader.sort(function (a, b) {
          return a.columnOrder - b.columnOrder;
        })
      : [];
  }

  getValue(element: any, value: string) {
    if (element[value] instanceof Array) {
      var retorno = "";
      (element[value] as Array<any>).forEach((e) => {
        retorno += e.display + ", ";
      });
      return retorno.slice(0, -2);
    } else {
      switch (value.split(".").length) {
        case 2:
          return element[value.split(".")[0]]
            ? element[value.split(".")[0]][value.split(".")[1]]
            : "";
        case 3:
          return element[value.split(".")[0]] &&
            element[value.split(".")[0]][value.split(".")[1]]
            ? element[value.split(".")[0]][value.split(".")[1]][
                value.split(".")[2]
              ]
            : "";
        case 4:
          return element[value.split(".")[0]] &&
            element[value.split(".")[0]][value.split(".")[1]] &&
            element[value.split(".")[0]][value.split(".")[1]][
              value.split(".")[2]
            ]
            ? element[value.split(".")[0]][value.split(".")[1]][
                value.split(".")[2]
              ][value.split(".")[3]]
            : "";
        default:
          return element[value];
      }
    }
  }

  async agregar() {
    this.openModal(
      this.field.formHijo,
      this.field.valueChangeCallbackModal,
      OperacionAbmEnum.Crear
    );
  }

  hidden() {
    return this.field.visible === false;
  }

  async editar(element: any) {
    var propNames = Object.getOwnPropertyNames(element);
    propNames.forEach((p) => {
      if (this.field.formHijo.filter((f) => f.name === p)[0])
        this.field.formHijo.filter((f) => f.name === p)[0].value = element[p];
    });
    this.openModal(
      this.field.formHijo,
      this.field.valueChangeCallbackModal,
      OperacionAbmEnum.Editar
    );
  }

  downloadFile(element: any) {
      const source = element.archivo;
      const link = document.createElement("a");
      link.href = source;
      link.download = element.nombre;
      link.click();
  }

  openModal(formFields: FieldConfig[], valueChangeModal: any, operacion: OperacionAbmEnum) {

    if (operacion === OperacionAbmEnum.Crear) {
      formFields.forEach(x => {
        x.value = null;
      });
    }

    this.modalAgregar = this.modalService.open(ModalAbmComponent, {
      ariaLabelledBy: "modal-basic-title",
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    this.modalAgregar.componentInstance.formFields = formFields;
    this.modalAgregar.componentInstance.modalRef = this.modalAgregar;
    this.modalAgregar.componentInstance.operacion = operacion;
    this.modalAgregar.componentInstance.valueChangeCallbackModal =
      valueChangeModal;
    this.modalAgregar.result.then((result) => {
      if (result) {
        if (operacion === OperacionAbmEnum.Crear)
          this.oneToManyService.agregadoOneToMany
            .get(this.field.name)
            .next(result);
        else
          this.oneToManyService.editadoOneToMany
            .get(this.field.name)
            .next(result);
        this.submitService.submit.next(false);
      }
    });
  }

  eliminar(row: any) {
    this.confirmationDialogService
      .confirm("Atención", "¿Está seguro que quiere quitar el registro?")
      .then((confirmed) => {
        if (confirmed) {
          this.oneToManyService.eliminadoOneToMany
            .get(this.field.name)
            .next(row);
        }
      });
  }

  noEsVer() {
    return this.field.esVer ? this.field.esVer : false;
  }
}
